import axios from "axios";

export function searchSecurityLogs(securityLogSearchRequest) {
  return axios
    .get(process.env.REACT_APP_API + "/admin/securityLogs/search", {
      params: new URLSearchParams(securityLogSearchRequest),
    })
    .then((response) => response.data);
}
